"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Casestudyshowcase() {
  const containerRef = useRef<HTMLDivElement>(null);
  const caseStudies = [{
    number: "01",
    category: "ENGENHARIA",
    title: "Produção de Latas",
    description: "Otimize as suas operações de lavagem, secagem e revestimento de latas para melhorar a eficiência e reduzir o desperdício.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.18.46.png?v=m5tpij4zay",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.18.46.png?v=6nzayj0zbm7-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.18.46.png?v=7d95lwp6kar-wvc-sizes",
    alt: "Sistemas de pulverização e engenharia de refrigeração industrial"
  }, {
    number: "02",
    category: "EXPERIÊNCIA",
    title: "Lavagem de Automóveis",
    description: "Obtenha o impacto, o caudal, o ângulo de pulverização e o tamanho de gota necessários para cada etapa de lavagem do seu processo.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.03.png?v=ue4dk767xf",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.03.png?v=b0vi8ixd9x8-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.03.png?v=34pxsqkocyb-wvc-sizes",
    alt: "Consultoria técnica e sistemas de limpeza de tanques"
  }, {
    number: "03",
    category: "COBERTURA",
    title: "Fabrico de Drones e UAV",
    description: "Apoie a produção de drones de elevado desempenho com soluções de pulverização para arrefecimento, proteção de sensores e revestimentos estruturais.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.22.png?v=atpjutkxz9k",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.22.png?v=wfkei8bepgh-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.22.png?v=i5t0jwb3cgj-wvc-sizes",
    alt: "Sistemas de pulverização e suporte técnico industrial"
  }];
  useGSAP(() => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;
    gsap.from(".study-card", {
      opacity: 0,
      y: 36,
      stagger: 0.15,
      duration: 0.75,
      ease: "power3.out",
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top 80%"
      }
    });
  }, {
    scope: containerRef
  });
  return <section data-section-id="31348" id="casestudyshowcase" ref={containerRef} className="relative overflow-hidden bg-background text-foreground py-24 md:py-32">
      <div className="relative mx-auto max-w-[1360px] px-5 sm:px-8 lg:px-14">
        {}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-20">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-4">
              <span aria-hidden="true" className="block h-px w-6" style={{
              backgroundColor: "var(--primary)"
            }} />
              <span className="font-default text-xs font-medium uppercase tracking-widest" style={{
              color: "var(--muted-foreground)"
            }}>
                Outras Indústrias & Serviços
              </span>
            </div>
            <h2 className="font-default text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground">Outras Industrias.</h2>
          </div>

          <div className="shrink-0">
            <Button asChild variant="outline" className="h-auto rounded-lg border border-border bg-card px-5 py-3 text-foreground transition-colors hover:bg-accent hover:text-accent-foreground">
              <Link to="/ContactsPage" className="inline-flex items-center gap-2">
                <span className="font-default text-sm font-medium">Fale com um especialista</span>
                <ArrowUpRight className="size-4" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {caseStudies.map((cs, i) => <article key={i} data-index={i} className="study-card group flex flex-col overflow-hidden rounded-3xl border border-border/80 bg-card p-6 sm:p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
              {}
              <div className="relative w-full aspect-[3/2] overflow-hidden rounded-xl bg-muted mb-6">
                <img src={cs.image} data-wvc-srcset={cs.srcset} data-wvc-sizes={cs.sizes} alt={cs.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
              </div>

              {}
              <span className="font-default text-xs font-medium uppercase tracking-widest text-muted-foreground mb-2 block">
                {cs.number} — {cs.category}
              </span>

              {}
              <h3 className="font-default text-xl sm:text-2xl font-bold text-foreground mb-3 leading-snug">
                {cs.title}
              </h3>

              {}
              <p className="font-default text-sm sm:text-base text-muted-foreground leading-relaxed">
                {cs.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}